module.exports = __webpack_public_path__ + "img/excalIco.46652da6.jpeg";